import { ResetPasswordPage } from "pages/reset-password";

export default function ResetPasswordRoute() {
  return <ResetPasswordPage />;
}
